import { TemplatesService } from '@/services';
import { TemplateTags } from '@/types/filters';
import { writable } from 'svelte/store';
const initialState = {
    items: [],
    error: '',
    selected: null,
    tags: [],
    page: 1,
    pages: 0,
    total: 0
};
// Init state
const { subscribe, update } = writable(initialState);
let __templates = [];
const getTemplateTags = () => {
    let tags = TemplateTags.map((item, i) => {
        return {
            id: i + 1,
            label: item,
            value: item
        };
    });
    return tags;
};
const actions = {
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    async getTemplates(page, limit, shape, selectedTags, favorites, changed) {
        const templates = await new TemplatesService().getTemplatesList(page, limit, shape, selectedTags, favorites);
        if (templates.length <= 0)
            return false;
        if (changed || page == 1) {
            __templates = templates;
        }
        else {
            __templates = __templates.concat(templates);
        }
        const tags = getTemplateTags();
        update(ts => {
            return {
                ...ts,
                tags,
                items: __templates
            };
        });
        return true;
    },
    async getTemplate(id) {
        const template = await new TemplatesService().getTemplate(id);
        if (template) {
            update(ts => {
                return {
                    ...ts,
                    selected: template
                };
            });
            return template;
        }
    },
    select(item) {
        update(ts => ({
            ...ts,
            selected: item
        }));
    }
};
const templates = {
    ...actions,
    subscribe
};
export default templates;
